import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sso-description" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "form-group d-flex align-items-center" }
const _hoisted_4 = { for: "enabled" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_6 = {
  key: 0,
  class: "ml-3"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "displayName" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_12 = {
  key: 0,
  class: "form-group"
}
const _hoisted_13 = { for: "companyShortName" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "providerType" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", {
  value: "Microsoft",
  title: "Microsoft"
}, " Microsoft ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  value: "Google",
  title: "Google"
}, " Google ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "Okta",
  title: "Okta"
}, " Okta ", -1)
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "clientId" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { for: "objectId" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { for: "directoryId" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { for: "secret" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { for: "authUrl" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_37 = { key: 4 }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { key: 5 }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_copy_paste = _resolveComponent("ag-copy-paste")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "p-4",
    onSubmit: _ctx.onSubmit,
    ref: "form",
    "validation-schema": _ctx.formValues.providerType === 'Microsoft' ? _ctx.schema : _ctx.formValues.providerType =='Google' ? _ctx.googleSchema: _ctx.oktaSchema,
    "initial-values": _ctx.formValues
  }, {
    default: _withCtx(({ meta }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.formValues.providerType=="Microsoft"? _ctx.$t("ssoUriDesc") : _ctx.formValues.providerType=="Google" ? _ctx.$t("ssoUriDescGoogle"): _ctx.$t("ssoUriDescOkta")), 1),
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.registerUri) + " ", 1),
          _createVNode(_component_ag_copy_paste, { text: _ctx.registerUri }, null, 8, ["text"])
        ])
      ]),
      _createVNode(_component_Field, {
        name: "enabled",
        class: "mb-4"
      }, {
        default: _withCtx(({ field, meta }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t("enable_provider")) + " ", 1),
              _hoisted_5
            ]),
            _createVNode(_component_Toggle, _mergeProps({
              modelValue: _ctx.isEnable,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isEnable) = $event)),
              name: "enabled"
            }, field, {
              class: ["ml-3", { 'form-error-input': meta.touched && !meta.valid }],
              onChange: _ctx.toggleStatus
            }), null, 16, ["modelValue", "onChange", "class"]),
            (_ctx.companyDomain)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("a", {
                    href: `https://${_ctx.companyDomain}`,
                    target: "_blank"
                  }, _toDisplayString(_ctx.companyDomain), 9, _hoisted_8)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_error_message, {
              class: "form-error-label",
              name: "enabled"
            })
          ])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Field, { name: "displayName" }, {
        default: _withCtx(({ field, meta }) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("provider_name")) + " ", 1),
              _hoisted_11
            ]),
            _createElementVNode("input", _mergeProps({
              name: "displayName",
              type: "text",
              maxlength: "191"
            }, field, {
              class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
              id: "displayName"
            }), null, 16),
            _createVNode(_component_error_message, {
              class: "form-error-label",
              name: "displayName"
            })
          ])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Field, { name: "companyShortName" }, {
        default: _withCtx(({ field, meta }) => [
          (_ctx.isCompanyScope)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_ctx.$t("companyShortName")) + " ", 1),
                  _hoisted_14
                ]),
                _createElementVNode("input", _mergeProps({
                  name: "companyShortName",
                  type: "text",
                  disabled: "",
                  maxlength: "191"
                }, field, {
                  class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                  id: "companyShortName"
                }), null, 16),
                _createVNode(_component_error_message, {
                  class: "form-error-label",
                  name: "companyShortName"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Field, { name: "providerType" }, {
        default: _withCtx(({ meta }) => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.$t("providerType")) + " ", 1),
              _hoisted_17
            ]),
            _withDirectives(_createElementVNode("select", {
              name: "providerType",
              id: "providerType",
              class: _normalizeClass(["form-control", { 'form-error-input': meta.touched && !meta.valid }]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValues.providerType) = $event))
            }, _hoisted_21, 2), [
              [_vModelSelect, _ctx.formValues.providerType]
            ])
          ])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Field, { name: "clientId" }, {
        default: _withCtx(({ field, meta }) => [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, [
              _createTextVNode(_toDisplayString(_ctx.$t("clientId")) + " ", 1),
              _hoisted_24
            ]),
            _createElementVNode("input", _mergeProps({
              name: "clientId",
              type: "password",
              maxlength: "191"
            }, field, {
              class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
              id: "clientId"
            }), null, 16),
            _createVNode(_component_error_message, {
              class: "form-error-label",
              name: "clientId"
            })
          ])
        ]),
        _: 2
      }, 1024),
      (_ctx.formValues.providerType == 'Microsoft')
        ? (_openBlock(), _createBlock(_component_Field, {
            key: 0,
            name: "objectId"
          }, {
            default: _withCtx(({ field, meta }) => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_ctx.$t("objectId")) + " ", 1),
                  _hoisted_27
                ]),
                _createElementVNode("input", _mergeProps({
                  name: "objectId",
                  type: "password",
                  maxlength: "191"
                }, field, {
                  class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                  id: "objectId"
                }), null, 16),
                _createVNode(_component_error_message, {
                  class: "form-error-label",
                  name: "objectId"
                })
              ])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      (_ctx.formValues.providerType == 'Microsoft')
        ? (_openBlock(), _createBlock(_component_Field, {
            key: 1,
            name: "directoryId"
          }, {
            default: _withCtx(({ field, meta }) => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_ctx.$t("directoryId")) + " ", 1),
                  _hoisted_30
                ]),
                _createElementVNode("input", _mergeProps({
                  name: "directoryId",
                  type: "password",
                  maxlength: "191"
                }, field, {
                  class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                  id: "directoryId"
                }), null, 16),
                _createVNode(_component_error_message, {
                  class: "form-error-label",
                  name: "directoryId"
                })
              ])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      (_ctx.formValues.providerType == 'Google' || _ctx.formValues.providerType =='Okta')
        ? (_openBlock(), _createBlock(_component_Field, {
            key: 2,
            modelValue: _ctx.formValues.secret,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formValues.secret) = $event)),
            name: "secret"
          }, {
            default: _withCtx(({ field, meta }) => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.$t("secret")) + " ", 1),
                  _hoisted_33
                ]),
                _createElementVNode("input", _mergeProps({
                  name: "secret",
                  type: "password",
                  maxlength: "191"
                }, field, {
                  class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                  id: "secret"
                }), null, 16),
                _createVNode(_component_error_message, {
                  class: "form-error-label",
                  name: "secret"
                })
              ])
            ]),
            _: 2
          }, 1032, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.formValues.providerType =='Okta')
        ? (_openBlock(), _createBlock(_component_Field, {
            key: 3,
            modelValue: _ctx.formValues.authUrl,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formValues.authUrl) = $event)),
            name: "authUrl"
          }, {
            default: _withCtx(({ field, meta }) => [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_ctx.$t("authUrl")) + " ", 1),
                  _hoisted_36
                ]),
                _createElementVNode("input", _mergeProps({
                  name: "authUrl",
                  type: "text",
                  maxlength: "191"
                }, field, {
                  class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                  id: "authUrl",
                  placeholder: "ex: https://{your_company_domain}.okta.com"
                }), null, 16),
                _createVNode(_component_error_message, {
                  class: "form-error-label",
                  name: "authUrl"
                })
              ])
            ]),
            _: 2
          }, 1032, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.type == 'edit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteProvider())),
              class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary mr-2"
            }, _toDisplayString(_ctx.$t("delete_provider")), 1),
            _createElementVNode("button", {
              type: "submit",
              disabled: !meta.valid,
              class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary"
            }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_38)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'create')
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("button", {
              type: "submit",
              disabled: !meta.valid,
              class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary"
            }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_40)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema", "initial-values"]))
}